import { useCallback, useState } from 'react';

export default function useCallbackRef() {
  const [element, setElement] = useState(null);
  const reference = useCallback(node => setElement(node), []);

  return [reference, element];
}
